export const globalVar = {
  namespace: true,
  state: { fecha: null,item:{},dataRI:{},dataGlobal:{} },
  mutations: {
     setDateCita(state,data){        
          state.fecha = data
    },
    setDataItem(state,data){        
          state.item = data
    },
    setDataRI(state,data){
        state.dataRI = data
    },
    setSeacrhPaciente(state,data){
      state.dataGlobal = data
    },
  },
};
